var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8141_29101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67676 21C4.67676 16.1375 7.95551 12.1963 11.9993 12.1963C16.043 12.1963 19.3218 16.1375 19.3218 21",
    stroke: "url(#paint0_radial_8141_29101)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1327 7.65877C16.1327 8.47635 15.8903 9.27557 15.4361 9.95536C14.9819 10.6352 14.3362 11.165 13.5809 11.4779C12.8256 11.7907 11.9944 11.8726 11.1925 11.7131C10.3907 11.5536 9.6541 11.1599 9.07598 10.5818C8.49787 10.0037 8.10417 9.2671 7.94467 8.46523C7.78516 7.66336 7.86703 6.8322 8.1799 6.07686C8.49277 5.32151 9.02261 4.67591 9.7024 4.22169C10.3822 3.76746 11.1814 3.52502 11.999 3.52502H16.1327V7.65877Z",
    stroke: "url(#paint1_radial_8141_29101)",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8141_29101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9977 23.3066) rotate(-148.876) scale(25.0029 75.272)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8141_29101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2079 13.9586) rotate(-134.873) scale(17.1259 58.2588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8141_29101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.86d902ac9080830695d05c5f008d6bd3.svg";
export { ForwardRef as ReactComponent };